// extracted by mini-css-extract-plugin
module.exports = {"container":"PlatformCheckboxList_container__12FoP","label":"PlatformCheckboxList_label__2UuoM","platform":"PlatformCheckboxList_platform__31FJg"};